<div style="display: flex; gap: 16px; width: 100%; margin-top: 20px;">
  <mat-form-field appearance="fill" style="flex: 1;">
    <mat-label>Station</mat-label>
    <mat-select [(value)]="stationSelected" (selectionChange)="setTableWinmediaPreselectMonthlyPlaylist()">
      <mat-option *ngFor="let station of stations" [value]="station">{{ station.label }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill" style="flex: 1;">
    <mat-label>Mois</mat-label>
    <mat-select [(value)]="selectedMonth" (selectionChange)="setTableWinmediaPreselectMonthlyPlaylist()">
      <mat-option *ngFor="let monthOption of monthOptions" [value]="monthOption">{{ monthOption.label }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<!-- Barre d'actions -->
<div style="display: flex; gap: 16px; align-items: center; margin-bottom: 16px; padding: 16px; background-color: #f5f5f5; border-radius: 4px;">
  <div style="flex: 1; display: flex; align-items: center; gap: 8px;">
    <button
      *ngIf="!isEditMode"
      mat-raised-button
      color="primary"
      (click)="openFinalizeDialog()"
      style="height: 56px;">
      <mat-icon style="margin-right: 8px;">edit</mat-icon>
      Mode édition
    </button>

    <button
      *ngIf="isEditMode"
      mat-raised-button
      color="warn"
      (click)="exitEditMode()"
      style="height: 56px;">
      <mat-icon style="margin-right: 8px;">arrow_back</mat-icon>
      Quitter le mode édition
    </button>

    <button
      *ngIf="isEditMode"
      mat-raised-button
      (click)="exportToCsv()"
      style="height: 56px;">
      <mat-icon style="margin-right: 8px;">file_download</mat-icon>
      Exporter CSV
    </button>
  </div>

  <div *ngIf="isEditMode" style="display: flex; align-items: center; gap: 12px;">
    <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
      <span style="font-size: 11px; font-weight: bold; letter-spacing: 0.5px; color: #888;">ÉTAPE 1</span>
      <button
        mat-raised-button
        [color]="isLocked ? 'primary' : 'warn'"
        [style.background-color]="isLocked ? '#e74c3c' : '#27ae60'"
        [disabled]="isSentWinmedia || isSentLaravel"
        [matTooltip]="(isSentWinmedia || isSentLaravel) ? 'La sélection a déjà été envoyée, les votes ne peuvent plus être déverrouillés' : ''"
        (click)="togglePlaylistLock()"
        style="height: 56px;">
        <mat-icon style="margin-right: 8px;">{{ isLocked ? 'lock' : 'lock_open' }}</mat-icon>
        {{ isLocked ? 'Votes verrouillés' : 'Verrouiller les votes' }}
      </button>
    </div>

    <mat-icon style="color: #bbb; margin-top: 14px;">chevron_right</mat-icon>

    <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
      <span style="font-size: 11px; font-weight: bold; letter-spacing: 0.5px; color: #888;">ÉTAPE 2</span>
      <mat-form-field appearance="fill" subscriptSizing="dynamic" style="width: 150px; height: 56px;"
                      [matTooltip]="(isSentWinmedia || isSentLaravel) ? 'La sélection a déjà été envoyée, la limite ne peut plus être modifiée' : ''">
        <mat-label>Limite sélection</mat-label>
        <input
          matInput
          type="number"
          [(ngModel)]="selectionLimit"
          (input)="onSelectionLimitInput($event)"
          [disabled]="isSentWinmedia || isSentLaravel"
          min="1"
          placeholder="Ex: 25">
      </mat-form-field>
    </div>

    <mat-icon style="color: #bbb; margin-top: 14px;">chevron_right</mat-icon>

    <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
      <span style="font-size: 11px; font-weight: bold; letter-spacing: 0.5px; color: #888;">ÉTAPE 3</span>
      <button
        mat-raised-button
        color="accent"
        [disabled]="!isLocked || (isSentWinmedia && isSentLaravel)"
        [matTooltip]="(isSentWinmedia && isSentLaravel)
          ? ('Envoyée le ' + (sentAt | date:'dd/MM/yyyy HH:mm'))
          : (!isLocked ? 'Verrouillez les votes avant envoi' : 'Winmedia: ' + (isSentWinmedia ? 'OK' : 'à envoyer') + ' / Le Son Unique: ' + (isSentLaravel ? 'OK' : 'à envoyer'))"
        (click)="openSendFinalizedPlaylistDialog()"
        style="height: 56px;">
        <mat-icon style="margin-right: 8px;">send</mat-icon>
        {{ (isSentWinmedia && isSentLaravel) ? 'Sélection envoyée' : (isSentWinmedia || isSentLaravel) ? 'Réessayer l\'envoi' : 'Envoyer la sélection finalisée' }}
      </button>
    </div>
  </div>
</div>

<h3 style="text-align: center;">
  Selection playlist "{{ selectedMonth.label }}" {{ (stationSelected && stationSelected.id !== 0) ? 'pour ' + stationSelected.label : '' }}
  <span *ngIf="isEditMode" style="color: #27ae60; font-weight: bold;"> - MODE ÉDITION</span>
</h3>

<table
  style="width: 100%"
  mat-table
  [dataSource]="mediasMatTable"
  matSort
  [matSortActive]="isEditMode ? 'position' : 'imedia'"
  [matSortDirection]="isEditMode ? 'asc' : 'desc'"
  cdkDropList
  [cdkDropListDisabled]="!isEditMode || !isEffectivelyLocked"
  (cdkDropListDropped)="drop($event)">

  <!-- Colonne drag handle (mode édition + verrouillé uniquement) -->
  <ng-container matColumnDef="dragHandle">
    <th mat-header-cell *matHeaderCellDef style="width: 50px;"></th>
    <td mat-cell *matCellDef="let element" style="width: 50px;"
        [style.opacity]="isEffectivelyLocked ? 1 : 0.3">
      <mat-icon [svgIcon]="'drag-handle'"
                (mousedown)="isEffectivelyLocked && armDragHandle()"
                (touchstart)="isEffectivelyLocked && armDragHandle()"
                [style.cursor]="isEffectivelyLocked ? 'move' : 'not-allowed'"></mat-icon>
    </td>
  </ng-container>

  <!-- Colonne flèches haut/bas (mode édition + verrouillé uniquement) -->
  <ng-container matColumnDef="positionControls">
    <th mat-header-cell *matHeaderCellDef style="width: 40px;"></th>
    <td mat-cell *matCellDef="let element" style="width: 40px; padding: 0;">
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px;">
        <button mat-icon-button
                class="reorder-arrow-btn"
                [disabled]="!canReorder() || medias.indexOf(element) <= 0"
                (click)="moveMediaUp(element)"
                style="width: 24px; height: 24px; line-height: 24px; padding: 0;"
                matTooltip="Monter d'une position">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; line-height: 18px;">keyboard_arrow_up</mat-icon>
        </button>
        <button mat-icon-button
                class="reorder-arrow-btn"
                [disabled]="!canReorder() || medias.indexOf(element) >= medias.length - 1"
                (click)="moveMediaDown(element)"
                style="width: 24px; height: 24px; line-height: 24px; padding: 0;"
                matTooltip="Descendre d'une position">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; line-height: 18px;">keyboard_arrow_down</mat-icon>
        </button>
      </div>
    </td>
  </ng-container>

  <!-- Colonne position (stockée si verrouillée, sinon dynamique basée sur score) -->
  <ng-container matColumnDef="position">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="isEditMode" style="width: 80px;"
        [title]="isLocked ? 'Position verrouillée' : 'Position basée sur le score bayésien'">
      #
    </th>
    <td mat-cell *matCellDef="let element" style="width: 80px;">
      <!-- Mode édition + verrouillé : position éditable manuellement -->
      <ng-container *ngIf="isEditMode && canReorder()">
        <input type="number" min="1" [max]="medias.length"
               [value]="element.position"
               (change)="onPositionInput(element, $event)"
               class="position-input"
               style="width: 55px; text-align: center;">
      </ng-container>
      <!-- Sinon : affichage en lecture seule -->
      <ng-container *ngIf="!(isEditMode && canReorder())">
        <ng-container *ngIf="element.position !== undefined && element.position !== null">
          <span
            [style.color]="isLocked && isInSelection(element) ? '#27ae60' : '#666'"
            [style.font-weight]="isLocked && isInSelection(element) ? 'bold' : 'normal'">
            {{ element.position }}
          </span>
        </ng-container>
        <ng-container *ngIf="element.position === undefined || element.position === null">
          <span style="color: #666;">
            {{ getPosition(element.imedia) > 0 ? getPosition(element.imedia) : '-' }}
          </span>
        </ng-container>
      </ng-container>
    </td>
  </ng-container>

  <ng-container matColumnDef="score">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="isEditMode"
        title="Score pondéré (moyenne bayésienne) - les titres avec peu de votes sont tirés vers la moyenne globale">
      Score
    </th>
    <td mat-cell *matCellDef="let element">
      <div class="score-display">
        <span class="score-value">{{ getBayesianScore(element.imedia) | number:'1.1-3' }}</span>
        <span class="score-count">({{ getVoteCount(element.imedia) }})</span>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="player">
    <th mat-header-cell *matHeaderCellDef> Lecture </th>
    <td mat-cell style="padding: 8px 16px 8px 0px;" *matCellDef="let element">
      <div class="players-container">
        <!-- Player extrait court -->
        <div class="player-row">
          <div class="custom-audio-player">
            <audio #audioExtrait
                   [src]="extraitLocation + element.id + '.mp3'"
                   [attr.data-player-id]="'extrait-' + element.id"
                   preload="none"
                   (timeupdate)="onTimeUpdate($event, 'extrait-' + element.id)"
                   (loadedmetadata)="onLoadedMetadata($event, 'extrait-' + element.id)"
                   (ended)="onEnded($event, 'extrait-' + element.id)">
            </audio>
            <button class="play-btn" (click)="togglePlay(audioExtrait, 'extrait-' + element.id)">
              <mat-icon [svgIcon]="isPlaying['extrait-' + element.id] ? 'stop' : 'play'"></mat-icon>
            </button>
            <div class="seek-container">
              <span class="seek-label">Extrait</span>
              <input type="range"
                     class="seek-bar"
                     min="0"
                     [max]="duration['extrait-' + element.id] || 100"
                     [value]="currentTime['extrait-' + element.id] || 0"
                     (input)="onSeek($event, audioExtrait)">
            </div>
          </div>
        </div>

        <!-- Player version longue HLS -->
        <div class="player-row">
          <div class="custom-audio-player">
            <audio #audioHLS
                   [attr.data-player-id]="'hls-' + element.id"
                   preload="none"
                   (timeupdate)="onTimeUpdate($event, 'hls-' + element.id)"
                   (loadedmetadata)="onLoadedMetadata($event, 'hls-' + element.id)"
                   (ended)="onEnded($event, 'hls-' + element.id)">
            </audio>
            <button class="play-btn" (click)="togglePlayHLS(audioHLS, element, 'hls-' + element.id)">
              <mat-icon [svgIcon]="isPlaying['hls-' + element.id] ? 'stop' : 'play'"></mat-icon>
            </button>
            <div class="seek-container">
              <span class="seek-label">Complet</span>
              <input type="range"
                     class="seek-bar"
                     min="0"
                     [max]="duration['hls-' + element.id] || 100"
                     [value]="currentTime['hls-' + element.id] || 0"
                     (input)="onSeek($event, audioHLS)">
            </div>
          </div>
        </div>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="vote">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="isEditMode">
      <span style="white-space: nowrap;">Voter (★/10)</span>
      <mat-icon *ngIf="isEffectivelyLocked" style="font-size: 14px; margin-top: 8px;"
                [title]="isLocked ? 'Votes verrouillés par le comité' : 'Votes verrouillés (délai dépassé)'">lock</mat-icon>
    </th>
    <td mat-cell *matCellDef="let element" style="white-space: nowrap; padding: 8px 16px 8px 8px;">
      <div class="star-rating" [style.opacity]="isEffectivelyLocked ? 0.5 : 1" [style.pointer-events]="isEffectivelyLocked ? 'none' : 'auto'">
        <div *ngFor="let star of [1, 2, 3, 4, 5]" class="star-container"
             [style.color]="getStarColor(star, getUserScore(element.imedia))">
          <span class="star-half left"
                (click)="setScore(element, star * 2 - 1)"
                [title]="isEffectivelyLocked ? 'Votes verrouillés' : (star * 2 - 1) + '/10'">
          </span>
          <span class="star-half right"
                (click)="setScore(element, star * 2)"
                [title]="isEffectivelyLocked ? 'Votes verrouillés' : (star * 2) + '/10'">
          </span>
          <span class="star-display">{{ getStarDisplay(star, getUserScore(element.imedia)) }}</span>
        </div>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="performer_title">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="isEditMode" class="mat_header_left"> Artiste / Titre </th>
    <td mat-cell *matCellDef="let element">
      <div style="display: flex; align-items: center; gap: 10px;">
        <img
          [src]="'https://lesonunique.com/storage/winmedia/pochettes_thumbnail/' + element.id + '.jpg'"
          (error)="$any($event.target).src = 'https://lesonunique.com/storage/winmedia/pochettes_thumbnail/noimage.jpg'"
          alt="Pochette"
          style="width: 45px; height: 45px; object-fit: cover; border-radius: 4px;"
        />
        <div>
          <div style="font-weight: bold;">
            {{ element.performer }}
          </div>
          <div style="font-style: italic;">
            {{ element.title }} {{ element.version?.length > 0 ? '(' + element.version + ')' : '' }}
          </div>
        </div>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="genre">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="isEditMode"> Genre </th>
    <td mat-cell *matCellDef="let element"> {{ element.genre }} </td>
  </ng-container>

  <ng-container matColumnDef="mood3">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="isEditMode"> Mood3 </th>
    <td mat-cell *matCellDef="let element"> {{ element.mood3 }} </td>
  </ng-container>

  <ng-container matColumnDef="voix">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="isEditMode"> Voix </th>
    <td mat-cell *matCellDef="let element"> {{ element.voix }} </td>
  </ng-container>

  <ng-container matColumnDef="proprietes">
    <th mat-header-cell *matHeaderCellDef> Propriétés </th>
    <td mat-cell *matCellDef="let element" style="padding: 6px 16px;">
      <mat-chip-list>
        <mat-chip *ngFor="let propriete of extractValues(element.proprietes)"
                  [style.background-color]="'#3d465a'"
                  style="margin: 4px;">
          <span style="color: white; font-size: 14px;">{{ propriete }}</span>
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="release">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="isEditMode"> Date sortie </th>
    <td mat-cell *matCellDef="let element"> {{ element.release_date }} </td>
  </ng-container>

  <ng-container matColumnDef="modify">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="isEditMode"> Import </th>
    <td mat-cell *matCellDef="let element"> {{ element.modify | date:'dd/MM/yyyy HH:mm' }} </td>
  </ng-container>

  <ng-container matColumnDef="proprietaire">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="isEditMode"> Propriétaire </th>
    <td mat-cell *matCellDef="let element">
      <mat-chip [style.background-color]="'#3d465a'"
                style="margin: 4px;">
        <span style="color: white; font-size: 14px;">{{ element.proprietaire }}</span>
      </mat-chip>
    </td>
  </ng-container>

  <ng-container matColumnDef="votes_detail">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="isEditMode"> Votes (★/10) </th>
    <td mat-cell *matCellDef="let element" style="padding: 6px 16px;">
      <mat-chip-list>
        <mat-chip *ngFor="let vote of getMediaVotes(element.imedia)"
                  [style.background-color]="getStarColor(0, vote.score_vote, vote.id_user !== userId)"
                  style="margin: 4px;">
          <span style="color: white; font-size: 14px;">{{ vote.user_name }}: {{ vote.score_vote }}★</span>
        </mat-chip>
      </mat-chip-list>
    </td>
  </ng-container>

  <ng-container matColumnDef="imedia">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="isEditMode"> IMedia </th>
    <td mat-cell style="padding-right: 40px" *matCellDef="let element"> {{ element.imedia }} </td>
  </ng-container>

  <!-- Colonne actions (mode édition uniquement) -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> Actions </th>
    <td mat-cell *matCellDef="let element">
      <span
        *ngIf="isInSelection(element)"
        matTooltip="Ce titre fait partie de la sélection finale"
        style="color: #27ae60; font-weight: bold;">
        ✓ Sélectionné
      </span>
      <span
        *ngIf="!isInSelection(element)"
        style="color: #999;">
        Non sélectionné
      </span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="isEditMode ? displayedColumnsEditMode : displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: isEditMode ? displayedColumnsEditMode : displayedColumns;"
    [class.voted-row]="!isEditMode && hasUserVoted(row.imedia)"
    [class.selected-row]="isEditMode && isInSelection(row)"
    cdkDrag
    [cdkDragDisabled]="!isEditMode || !dragHandleArmed"></tr>
</table>

<div *ngIf="loading" class="edit-spinner-container">
  <mat-progress-spinner class="mat-progress-spinner-editwin" mode="indeterminate"></mat-progress-spinner>
</div>

<mat-paginator #Paginator [length]="medias.length"
               [pageSize]="100" [pageSizeOptions]="[100, 200, 500]" showFirstLastButtons></mat-paginator>
